<template>
  <modal
    :name="'cancelSubscriptionModal'"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
    id="cancelSubscriptionModal"
  >
    <modals-header
      :modalNameProp="$lang.messages.cancelSubscriptionModalTitle"
      @hideModalProp="hideCancelSubscriptionModal"
    />

    <hr class="v--modal-hr">

    <div class="fp-modal">
      <div>{{ $lang.messages.cancelSubscriptionModalText }}</div>
      <button
        type="button"
        class="generic-btn"
        @click="hideCancelSubscriptionModal"
      >
        {{ $lang.messages.cancelSubscriptionModalBtnNo }}
      </button>
      <button
        type="button"
        class="action-btn danger-btn"
        @click="cancelSubscription"
      >
        <span>{{ $lang.messages.cancelSubscriptionModalBtnYes }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
  import { mapActions } from "vuex";
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import { CANCEL_SUBSCRIPTION } from "@/store/action.types";
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "CancelSubscriptionModal",
    components: {
      'modals-header': modalsHeader
    },
    methods: {
      ...mapActions({
        cancelSubscriptionAction: CANCEL_SUBSCRIPTION
      }),
      /**
       * @description Show Cancel subscription modal
       */
      show() {
        this.$modal.show('cancelSubscriptionModal')
      },
      /**
       * @description Close Cancel subscription modal
       */
      hideCancelSubscriptionModal () {
        this.$modal.hide('cancelSubscriptionModal')
      },
      /**
       * @description Emit loadSubscriptions event to parent component to refresh subscription info
       */
      loadSubscriptions(setGotIt) {
        this.$emit("loadSubscriptions", setGotIt);
      },
      /**
       * @description Cancel the subscription on user confirm
       */
      cancelSubscription () {
        this.cancelSubscriptionAction()
          .then(() => {
            this.$snotify.success(this.$lang.messages.sn_subscriptionCanceledSuccess, 'SUCCESS')
            this.loadSubscriptions(true)
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.status.desc, 'ERROR')
            }
          })
        .finally(() => {
          this.hideCancelSubscriptionModal()
        })
      }
    }
  }
</script>

<style scoped>

</style>
